import * as actions from '../actions/index';

export const setViewerThunk = ({ variant }) => {
  return async (dispatch) => {
    try {
      const response = await fetch(`https://09v84ua8va.execute-api.us-east-1.amazonaws.com/dev/api/v1/viewer-settings/${variant}`);
      if(!response.ok) { throw new Error(`Error making call to viewer settings`) }
      const data = await response.json();
      dispatch(actions.setViewerSettings({ data }));
    } catch(error) {
      console.log('error', error);
    }
  }
};
